import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-233dca24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = {
  class: "flex justify-center text-center",
  style: {"height":"4.5rem"}
}
const _hoisted_3 = { class: "p-16" }
const _hoisted_4 = { class: "absolute top-8 right-8" }

import { ref, reactive, computed, nextTick } from 'vue';
import { RegionDto } from 'src/api/types';
import useWindowResize from 'src/utils/useWindowResize';

export interface SvThumbnailProps {
  regions: RegionDto[];
  gridClass: string;
  row?: number;
  ratio?: string;
  imageHeight?: string;
  flat?: boolean;
  showDesc?: boolean;
  showDialog?: boolean;
  autoplay?: boolean | number;
  infinite?: boolean | number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SvThumbnail',
  props: {
    regions: { default: () => [] },
    gridClass: {},
    row: { default: 1 },
    ratio: { default: '4/3' },
    imageHeight: { default: '200px' },
    flat: { type: Boolean, default: true },
    showDesc: { type: Boolean, default: true },
    showDialog: { type: Boolean, default: true },
    autoplay: { type: [Boolean, Number], default: false },
    infinite: { type: [Boolean, Number], default: false }
  },
  setup(__props: any) {

const props = __props;

const gridCols = ref('');
useWindowResize(async () => {
  await nextTick();
  const w = window.innerWidth;
  gridCols.value =
    w >= 1536
      ? '2xl'
      : w >= 1280
      ? 'xl'
      : w >= 1024
      ? 'lg'
      : w >= 768
      ? 'md'
      : w >= 640
      ? 'sm'
      : '';
});

const regionsArray = computed(() => {
  const reg = new RegExp(' ' + gridCols.value + ':grid-cols-(\\d)').exec(
    ' ' + props.gridClass
  );
  const cols = reg?.[1] ? parseInt(reg?.[1]) : 2;

  const result = [];
  let i = 0;
  while (true) {
    const array = props.regions.slice(i, i + cols * props.row);
    if (array.length > 0) {
      result.push(array);
      i += cols * props.row;
    } else break;
  }
  return result;
});

const state = reactive<{
  key?: number;
  value: number;
  visible: boolean;
}>({
  value: 0,
  visible: false,
});

return (_ctx: any,_cache: any) => {
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_carousel, {
      class: _normalizeClass(`w-full ${_ctx.row === 1 ? 'h-auto' : ''}`),
      modelValue: state.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.value) = $event)),
      animated: "",
      "transition-prev": "slide-right",
      "transition-next": "slide-left",
      swipeable: "",
      "control-color": "grey-6",
      "prev-icon": "mdi-chevron-left",
      "next-icon": "mdi-chevron-right",
      padding: "",
      arrows: "",
      autoplay: _ctx.autoplay,
      infinite: _ctx.infinite
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionsArray.value, (array, i) => {
          return (_openBlock(), _createBlock(_component_q_carousel_slide, {
            key: i,
            name: i,
            class: _normalizeClass(`p-0 grid grid-rows-${_ctx.row} ${_ctx.gridClass}`)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(array, (region, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: j,
                  class: "px-4"
                }, [
                  _createVNode(_component_q_card, { flat: _ctx.flat }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_img, {
                        src: region.image,
                        alt: region.name,
                        ratio: _ctx.ratio,
                        "initial-ratio": _ctx.ratio,
                        height: _ctx.imageHeight,
                        loading: "lazy",
                        onClick: 
                () => {
                  if (_ctx.showDialog) {
                    let key = 0;
                    regionsArray.value.slice(0, i).forEach((t) => {
                      key += t.length;
                    });

                    state.key = key + j;
                    state.visible = true;
                  }
                }
              
                      }, {
                        loading: _withCtx(() => [
                          _createVNode(_component_q_spinner_dots, {
                            color: "primary",
                            size: "1.5rem"
                          })
                        ]),
                        _: 2
                      }, 1032, ["src", "alt", "ratio", "initial-ratio", "height", "onClick"]),
                      (_ctx.showDesc)
                        ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, _toDisplayString(region.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["flat"])
                ]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["name", "class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["class", "modelValue", "autoplay", "infinite"]),
    _createVNode(_component_q_dialog, {
      class: "overflow-hidden",
      modelValue: state.visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.visible) = $event)),
      maximized: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_carousel, {
            class: "w-full h-full overflow-hidden bg-transparent",
            modelValue: state.key,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.key) = $event)),
            "transition-prev": "jump-right",
            "transition-next": "jump-left",
            swipeable: "",
            animated: "",
            "prev-icon": "mdi-chevron-left",
            "next-icon": "mdi-chevron-right",
            thumbnails: "",
            infinite: ""
          }, {
            "navigation-icon": _withCtx(({ active, onClick }) => [
              active
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: "bg-green-600 w-14 h-2",
                    padding: "0",
                    dense: "",
                    onClick: onClick
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    class: "bg-gray-500 w-14 h-2",
                    padding: "0",
                    dense: "",
                    onClick: onClick
                  }, null, 8, ["onClick"]))
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region, i) => {
                return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                  key: i,
                  name: i,
                  "img-src": region.image
                }, null, 8, ["name", "img-src"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createVNode(_component_q_btn, {
              size: "lg",
              "text-color": "primary",
              icon: "mdi-close",
              "no-caps": "",
              circle: "",
              round: ""
            }, null, 512), [
              [_directive_close_popup]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})